<template>
  <v-row align="center" justify="center">
    <v-dialog v-model="thanksModal" persistent max-width="70%">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row align="center" justify="center">
            <img src="../assets/feedback.svg" width="35%" class="ma-3" />
          </v-row>

          <v-row align="center" justify="center">
            <h1>¡Muchas Gracias!</h1>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <p class="textCenter">
                  Hemos recibido tu feedback, recuerda que estamos mejorando
                  para ti, si nos vuelves a necesitar sólo abre la app y
                  estaremos para ti.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <v-btn color="primary" block rounded @click="close()">
                  Entendido
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields(["thanksModal"]),
  },
  methods: {
    close() {
      location.reload()
      // this.thanksModal = false;
      // this.$router.push({ name: "Home" });
    },
  },
};
</script>

<style>
.textCenter {
  text-align: center;
  text-justify: distribute;
}
</style>